import * as React from "react"

import { DayPicker } from "react-day-picker"

import { cn } from "@/lib/utils"

export type CalendarProps = React.ComponentProps<typeof DayPicker>

function Calendar({ className, ...props }: CalendarProps) {
  const defaultToYear = new Date().getFullYear() + 5

  return (
    <DayPicker
      captionLayout="dropdown"
      hideNavigation
      weekStartsOn={1}
      className={cn("p-3", className)}
      classNames={{
        day: "p-0 rounded-md hover:bg-primary/70",
        today: "text-primary bg-palette-jungleGreen100",
        selected: "bg-primary text-primary-foreground",
        chevron: "text-primary-foreground",
      }}
      toYear={props.toYear ?? defaultToYear}
      {...props}
    />
  )
}
Calendar.displayName = "Calendar"

export { Calendar }
